import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { Calendar, CheckCircle, Clock, MapPin, Hotel as HotelIcon } from 'lucide-react';

const StatCard = ({ icon: Icon, label, value, color }) => (
  <div className="glass-card rounded-xl p-6 flex items-center gap-5">
    <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${color}`}>
      <Icon className="w-6 h-6 text-white" />
    </div>
    <div>
      <div className="text-3xl font-black text-white">{value}</div>
      <div className="text-white/60 text-sm">{label}</div>
    </div>
  </div>
);

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get('/admin/stats').then(r => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="text-3xl font-black text-white mb-2">Dashboard</h1>
      <p className="text-white/60 mb-8">Resumen general del sistema TTS</p>
      {stats && (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          <StatCard icon={Calendar} label="Total Reservas" value={stats.total_reservations} color="bg-[#ff6b1a]" />
          <StatCard icon={Clock} label="Pendientes" value={stats.pending} color="bg-yellow-600" />
          <StatCard icon={CheckCircle} label="Confirmadas" value={stats.confirmed} color="bg-green-600" />
          <StatCard icon={CheckCircle} label="Completadas" value={stats.completed} color="bg-blue-600" />
          <StatCard icon={MapPin} label="Excursiones" value={stats.excursions} color="bg-purple-600" />
          <StatCard icon={HotelIcon} label="Hoteles" value={stats.hotels} color="bg-pink-600" />
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
